import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from '../../../models/allpayments'; // Importing allpayments model
import { devConfig, countries, gamesCasino } from '../../../config/config'; // Importing configuration settings

/**
 * Class representing the tableMessagesView.
 * @extends JetView
 */
export default class tableMessagesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            type: 'wide', // Type of the datatable
                            view: 'datatable', // Webix datatable component
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('messageListEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'GlobalId', // Column ID
                                    header: 'Global Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientIdFrom', // Column ID
                                    header: _('Emisor'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientIdTo', // Column ID
                                    header: _('Receptor'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DateExpiration', // Column ID
                                    header: _('Fecha Expiración'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Title', // Column ID
                                    header: _('Asunto'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Message', // Column ID
                                    header: _('Mensaje'), // Column header with localization
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Leido'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: '1', value: _('Si') }, // Yes option
                                        { id: '0', value: _('No') }, // No option
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Event handler for edit button click
                                    $$('editwinMessages').show(); // Show edit window
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and binds events.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'Client/GetClientMessages'; // API URL for fetching messages
        var filter = ''; // Filter string for API requests
        var popup = webix.ui({
            // Configuration for the edit message popup
            view: 'window',
            id: 'editwinMessages', // ID for the edit window
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Editar Mensaje') }, // Label for the edit message
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Click event to hide the window
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: true, // Modal window
            body: {
                view: 'form', // Form inside the window
                id: 'editform', // ID for the edit form
                elements: [
                    {
                        rows: [
                            {
                                view: 'text', // Text input for User ID
                                label: _('ID Usuario'),
                                name: 'ClientIdTo',
                            },
                            { view: 'text', label: _('Asunto'), name: 'Title' }, // Text input for Title
                            {
                                view: 'ckeditor5', // CKEditor for message input
                                label: _('Mensaje'),
                                name: 'Message',
                                onReady(eventData) {
                                    // Event when CKEditor is ready
                                    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
                                        // Upload adapter for file uploads
                                        return new UploadAdapter(loader);
                                    };
                                },
                                ready: function (eventData) {
                                    // Event when CKEditor is ready
                                    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
                                        // Upload adapter for file uploads
                                        return new UploadAdapter(loader);
                                    };
                                },
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', // Button to close the form
                                value: _('Cerrar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the window
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset the add form values
                                    );
                                },
                            },
                        ],
                    },
                ],
            },
        });
        var popupAdd = webix.ui({
            // Configuration for the add message popup
            view: 'window',
            id: 'AddMessages', // ID for the add window
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Añadir Mensaje') }, // Label for the add message
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Click event to hide the window
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: true, // Modal window
            body: {
                view: 'form', // Form inside the window
                id: 'addform', // ID for the add form
                elements: [
                    {
                        rows: [
                            {
                                view: 'text', // Text input for User ID
                                label: _('ID Usuario'),
                                name: 'ClientId',
                            },
                            {
                                view: 'datepicker', // Datepicker for expiration date
                                label: _('Fecha Expiración'),
                                name: 'DateExpiration',
                                timepicker: true, // Enable time selection
                            },
                            { view: 'text', label: _('Asunto'), name: 'Title' }, // Text input for Title
                            {
                                view: 'richselect', // Rich select for country selection
                                name: 'CountrySelect',
                                id: 'CountrySelect',
                                label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                                hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Hide if permission denied
                                css: 'prm-filterByCountry', // CSS class for styling
                                placeholder: _('Click para seleccionar '), // Placeholder text
                                options: {
                                    body: {
                                        template: function (obj) {
                                            // Template for displaying country options
                                            return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                        },
                                        data: countries, // Data for country options
                                    },
                                },
                                hidden: devConfig.getCountryReport(), // Hide if country report is enabled
                            },
                            {
                                view: 'ckeditor5', // CKEditor for message input
                                label: _('Mensaje'),
                                name: 'Message',
                                onReady(eventData) {
                                    // Event when CKEditor is ready
                                    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
                                        // Upload adapter for file uploads
                                        return new UploadAdapter(loader);
                                    };
                                },
                                ready: function (eventData) {
                                    // Event when CKEditor is ready
                                    eventData.plugins.get('FileRepository').createUploadAdapter = function (loader) {
                                        // Upload adapter for file uploads
                                        return new UploadAdapter(loader);
                                    };
                                },
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', // Button to cancel the form
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the window
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset the add form values
                                    );
                                },
                            },
                            {
                                view: 'button', // Button to save the form
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    webix
                                        .ajax() // AJAX request to save message
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Client/SaveClientMessage',
                                            JSON.stringify(values), // Send form values as JSON
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        'Cell value was changed', // Show success message
                                                    );
                                                    grid.clearAll(); // Clear the grid
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset the add form values
                                    );
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        this.on(this.app, 'messages:filter', (filterData) => {
            // Event listener for filtering messages
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter string
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event listener for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        this.on(this.app, 'addMessage:button', (filter) => {
            // Event listener for showing add message popup
            popupAdd.show(); // Show add message window
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
    }
}

// FILE DOCUMENTED
